import { useWebSockets } from ".";

export const WebSocketGateway = () => {
  useWebSockets();
  return <></>;
};
